<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      // photo_default: "",
      pegawai: {
        user_id: localStorage.getItem("session_user_id"),
        jenis_pegawai: localStorage.getItem('user_pegawai'),
        username: null,
        nama: null,
        jabatan: null,
        unit: null,
        status: 0,
        last_login: null,
        created_at: null,
        updated_at: null,
      }
    }
  },

  mounted() {
    this.getData();
  },

  methods: {
    fullDateTimeFormat(datetime) {
      if (!datetime) return "-";
      return moment(datetime).format("YYYY-MM-DD HH:mm");
    },

    async getData() {
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "master/users-pegawai/" +
          this.pegawai.user_id,

        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      })
        .then((response) => response.data)
        .catch((err) => {
          console.log("err get data:", err);
          return false;
        });

      if (data) {
        console.log(data);
        this.pegawai.username = data.data?.u_nip;
        this.pegawai.nama = data.data?.nama;
        this.pegawai.jabatan = data.data?.jabatan;
        this.pegawai.unit = data.data?.u_namaunit1;
        this.pegawai.status = data.data?.active_flag;
        this.pegawai.last_login = data.data?.last_login;
        this.pegawai.created_at = data.data?.created_at;
        this.pegawai.updated_at = data.data?.updated_at;

        // this.edit_username = data.data?.username;
        // this.edit_name = data.data?.name;
      }

      Swal.close();
    },
  }
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12 col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h4 class="card-title mb-4">Foto Profil Akun Anda</h4>
              </div>
              
              <div class="col-md-12">
                <center>
                  <div class="position-relative mb-2">
                    <img
                      src="@/assets/images/users/avatar-9.png"
                      alt="Foto Profil Akun"
                      class="img-thumbnail"
                      style="width: 50%"
                    />
                  </div>

                  <h5 class="font-size-15 text-truncate">
                    {{ pegawai.username }}
                  </h5>
                  <p class="text-muted mb-0 text-truncate">
                    {{ pegawai.jenis_pegawai }}
                  </p>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h4 class="card-title mb-4">Data Profil Akun Anda</h4>
              </div>
              
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-nowrap mb-0">
                    <tbody>
                      <tr>
                        <th scope="row" style="width: 20%">Username</th>
                        <td>{{ pegawai.username }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Nama</th>
                        <td>{{ pegawai.nama }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Roles</th>
                        <td>
                          <span v-if="pegawai.jenis_pegawai == 'pegawai_internal'">Pegawai Internal</span>
                          <span v-else-if="pegawai.jenis_pegawai == 'pegawai_eksternal'">Pegawai Eksternal</span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Jabatan</th>
                        <td>{{ pegawai.jabatan }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Unit</th>
                      </tr>
                      <tr>
                        <th scope="row">Status Akun</th>
                        <td>
                          <div v-if="pegawai.status == 1">
                            <div
                              class="badge badge-pill badge-soft-success font-size-12"
                            >
                              ENABLE
                            </div>
                          </div>
                          <div v-else>
                            <div
                              class="badge badge-pill badge-soft-danger font-size-12"
                            >
                              DISABLE
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Terakhir Login ke Aplikasi</th>
                        <td>{{ fullDateTimeFormat(pegawai.last_login) }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Waktu Pembuatan Akun</th>
                        <td>{{ fullDateTimeFormat(pegawai.created_at) }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Waktu Perubahan Data Terakhir</th>
                        <td>{{ fullDateTimeFormat(pegawai.updated_at) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
  </Layout>
</template>
